import React from 'react'

export default function KitTestIntroCard(): React.JSX.Element {
    return (
        <div className="rounded-2xl border border-border bg-card p-6 shadow-[var(--shadow-card)]">
            <h1 className="text-2xl font-semibold text-foreground">Kit Test</h1>
            <p className="mt-2 text-sm text-muted-foreground">
                Add a profile to give the agent network context, or start
                without one to test the flow.
            </p>
        </div>
    )
}
